<script>
import PageLayout from '../components/js/Components/UI/PageLayout.vue'
import MainContainer from '../components/js/Components/UI/Content/MainContainer.vue'
import BlockContent from '../components/js/Components/UI/Content/BlockContent.vue'
import TableMenu from '../components/js/Components/UI/Table/TableMenu.vue'
import CardContent from '../components/js/Components/UI/Content/CardContent.vue'
import mixinComponent from '../components/js/Mixins/mixinComponent.js'
import { globalVariablesMixin } from '../components/js/Mixins/global.js'
import DataTable from '../components/js/Components/UI/Table/DataTable.vue'
import CancelSimulationConfirmationModal from '../components/js/Components/Simulation/CancelSimulationConfirmationModal.vue'
import { isEmpty } from '../components/Utils/emptyUtils'

export default {
  components: {
    CancelSimulationConfirmationModal,
    DataTable,
    CardContent,
    TableMenu,
    BlockContent,
    MainContainer,
    PageLayout,
  },
  mixins: [mixinComponent, globalVariablesMixin],
  data() {
    let urlParams = new URLSearchParams(window.location.search)
    return {
      id: null,
      def: {},
      createdAt: null,
      createdAtEnd: null,
      filters: {
        units: [],
        platformSalesmen: [],
        suppliers: [],
        clients: [],
        refinancers: [],
      },
      filterValues: {
        unit: null,
        platformSalesman: null,
        supplier: null,
        client: null,
        refinancer: null,
      },
      selectedStatus: urlParams.get('s') ?? 0,
      marketType: urlParams.get('marketType') || null,
      simulationToCancel: null,
      simulationListRequest: null,
    }
  },
  computed: {
    tableFilters() {
      return [
        { name: 'client', optionsKey: 'clients', domain: 'simulation', labelTop: true, condition: true },
        { name: 'supplier', optionsKey: 'suppliers', domain: 'simulation', labelTop: true, condition: true },
        { name: 'unit', optionsKey: 'units', domain: 'simulation', labelTop: true, condition: true },
        {
          name: 'platformSalesman',
          optionsKey: 'platformSalesmen',
          domain: 'simulation',
          labelTop: true,
          condition: true,
        },
        {
          name: 'refinancer',
          optionsKey: 'refinancers',
          domain: 'simulation',
          labelTop: true,
          condition: this.filters.refinancers.length > 1,
        },
        { name: 'simulationId', domain: 'simulation', labelTop: true, condition: false },
        { name: 'clientName', domain: 'simulation', labelTop: true, condition: false },
        { name: 'supplierName', domain: 'simulation', labelTop: true, condition: false },
        { name: 'platformSalesmanName', domain: 'simulation', labelTop: true, condition: false },
        { name: 'productName', domain: 'simulation', labelTop: true, condition: false },
      ].filter(({ condition }) => condition === true)
    },
    searchParams() {
      const searchParams = new URLSearchParams()

      const statuses = this.getStatusesArray()
      statuses.forEach((status) => {
        searchParams.append('statuses[]', status)
      })

      if (this.unit > 0) {
        searchParams.set('unit', this.unit)
      }

      if (this.platformSalesman > 0) {
        searchParams.set('platformSalesman', this.platformSalesman)
      }

      if (this.supplier > 0) {
        searchParams.set('supplier', this.supplier)
      }

      if (this.client > 0) {
        searchParams.set('client', this.client)
      }

      if (this.refinancer > 0) {
        searchParams.set('refinancer', this.refinancer)
      }

      if (this.createdAt) {
        searchParams.set('createdAt', this.createdAt)
      }
      if (this.createdAtEnd) {
        searchParams.set('createdAtEnd', this.createdAtEnd)
      }
      if (this.marketType) {
        searchParams.set('marketType', this.marketType)
      }

      return searchParams
    },
    submenuLabels() {
      return [
        { id: 0, name: this.$t('simulation.list.status.ALL') },
        { id: 1, name: this.$t('home.dashboardSimulation.status.waiting') },
        { id: 2, name: this.$t('home.dashboardSimulation.status.study') },
        { id: 3, name: this.$t('home.dashboardSimulation.status.accepted') },
        { id: 4, name: this.$t('home.dashboardSimulation.status.contract') },
        { id: 5, name: this.$t('home.dashboardSimulation.status.refused') },
        { id: 6, name: this.$t('home.dashboardSimulation.status.canceled') },
      ]
    },
    urlSimulation: function () {
      let url = 'quotations?'
      url += this.setUrl()
      return url
    },
    columns() {
      const isReadOnly = () => user.isReadOnly
      const isTheme = (expectedThemes) => expectedThemes.includes(conf.theme_dir)

      return [
        {
          name: 'id',
          title: this.$t('simulation.list.table.labelNumber'),
          formatter: 'context',
          style: { width: '60px;', orderByCol: 'id', className: 'col-align-center' },
          options: { renderType: 'simulation' },
        },
        { name: 'clientId', displayable: false },
        { name: 'supplierId', displayable: false },
        { name: 'accountCodeClient', displayable: false },
        { name: 'accountCodeSupplier', displayable: false },
        { name: 'platformId', displayable: false },
        {
          name: 'demandNumber',
          title: this.$t('simulation.list.table.labelDemandNumber'),
          displayable: isTheme(['yneia', 'lbp']),
          style: { width: '120px;' },
          options: { renderType: 'simulation' },
        },
        {
          name: 'createdAt',
          title: this.$t('simulation.list.table.labelCreatedAt'),
          type: 'date',
          formatter: 'date',
          style: { width: '140px;' },
        },
        {
          name: 'statusAt',
          title: this.$t('simulation.list.table.statusAt'),
          type: 'date',
          formatter: 'date',
          displayable: isTheme(['financia']),
        },
        {
          name: 'supplierNameOrSiren',
          title: this.$t('main.supplier'),
          formatter: 'entity',
          style: { width: '200px;' },
          options: { renderId: 'supplierId' },
        },
        {
          name: 'platformSalesmanName',
          title: this.$t('simulation.list.table.labelPlatformSalesman'),
        },
        {
          name: 'clientNameOrSiren',
          title: this.$t('main.client'),
          formatter: 'entity',
          style: { width: '150px;' },
          options: { renderId: 'clientId' },
        },
        {
          name: 'clientSiren',
          title: this.$t('contract.list.table.sirenClient'),
          formatter: 'entity',
          options: { render: '', renderId: 'clientId' },
          displayable: isTheme('hexapage'),
        },
        {
          name: 'platformName',
          title: this.$t('simulation.list.table.platformName'),
          formatter: 'entity',
          options: { renderId: 'platformId' },
          displayable: !isTheme(['financia']),
        },
        {
          name: 'companySalesmanName',
          title: this.$t('simulation.list.table.companySalesmanName'),
          displayable: !isTheme(['financia']),
        },
        {
          name: 'contractType',
          title: this.$t('simulation.list.table.labelContractType'),
          formatter: 'custom',
          displayable: !isTheme(['financia', 'itl']),
          options: {
            renderer: this.renderContractType,
          },
          style: { width: '80px;' },
        },
        {
          name: 'decisionAmount',
          title: this.$t('simulation.list.table.labelAmount'),
          displayable: !isTheme(['ciscar']),
          formatter: 'currency',
          type: 'num-fmt',
          style: { width: '60px;' },
        },
        {
          name: 'duration',
          title: this.$t('simulation.list.table.labelDuration'),
          type: 'numeric',
          style: { width: '40px;', className: 'col-align-center', format: 'currency' },
        },
        {
          name: 'equipmentType',
          title: this.$t('simulation.list.table.labelEquipmentType'),
          displayable: isTheme(['yneia']),
        },
        {
          name: 'nbRentFree',
          title: this.$t('simulation.list.table.labelRentFree'),
          displayable: isTheme(['lbp']),
          type: 'numeric',
          style: { width: '10px;', className: 'col-align-center' },
        },
        {
          name: 'analystName',
          title: this.$t('demand.fields.createdBy.label'),
          displayable: isTheme(['olinn', 'itl']),
          style: { width: '40px;' },
        },
        {
          name: 'refinancerName',
          title: this.$t('contract.list.table.refinancerName'),
          displayable: (isTheme(['olinn']) || isTheme(['ciscar'])) && (user.isBusinessMan || user.isAdmin),
          style: { width: '120px;' },
        },
        {
          name: 'refinancerStatus',
          displayable: false,
        },
        {
          name: 'decisionRent',
          title: this.$t('simulation.list.table.labelRent'),
          type: 'num-fmt',
          formatter: 'currency',
          style: { width: '50px', className: 'col-align-right' },
          options: { renderType: 'simulation' },
        },
        {
          name: 'orderNumber',
          title: this.$t('simulation.list.table.orderNumber'),
          displayable: isTheme('stelogy'),
          formatter: 'custom',
          options: {
            renderer: this.renderK2OrderNumber,
          },
        },
        {
          name: 'statusLabel',
          title: this.$t('simulation.list.table.labelStatus'),
          formatter: 'status',
          style: { width: '150px;' },
          options: { renderType: 'simulation' },
        },
        {
          name: 'contractMode',
          displayable: isTheme(['lbp']),
          title: this.$t('simulation.list.table.contractMode'),
          style: { width: '150px;' },
          options: { renderType: 'simulation' },
        },
        {
          name: 'id',
          displayable: !isReadOnly(),
          title: this.$t('simulation.delete'),
          formatter: 'action',
          style: { width: '60px;', className: 'text-center unfollow' },
          options: { renderType: 'delete' },
        },
      ]
    },
  },
  methods: {
    cancelPendingRequest() {
      this.simulationListRequest?.cancel()
      this.simulationListRequest = null
    },
    async loadFilterOptions() {
      try {
        const options = await this.getJSON(`quotations/filter-options?${this.searchParams.toString()}`)
        this.filters = options
      } catch {}
    },
    updateFilterData(filterDatas) {
      for (const [name, value] of Object.entries(filterDatas)) {
        if (!isEmpty(value)) {
          this.filterValues[name] = value
          this.searchParams.set(name, value)
        } else {
          this.filterValues[name] = undefined
          this.searchParams.delete(name)
        }
        this.renderTable()
      }
    },
    setDateTable(createdAt, createdAtEnd) {
      this.createdAt = createdAt
      this.createdAtEnd = createdAtEnd
      this.renderTable()
    },
    setSelectedStatus(value) {
      value = parseInt(value)
      if (value !== this.selectedStatus) {
        this.selectedStatus = value
      }
    },
    async getSimulations(callback, { page, limit, search, sort = [] }) {
      this.cancelPendingRequest()

      const searchParams = new URLSearchParams(this.searchParams.toString())
      if (this.marketType) {
        searchParams.set('marketType', this.marketType)
      } else {
        searchParams.delete('marketType')
      }
      searchParams.set('page', page)
      searchParams.set('limit', limit)

      for (let { field, order } of sort) {
        searchParams.set(`sort[${field}]`, order)
      }

      if (!!search) {
        searchParams.set('q', search)
      }

      this.simulationListRequest = this.getJSON(`v2/quotations?${searchParams.toString()}`)

      const { items: simulations, total } = await this.simulationListRequest
      callback({ data: simulations, recordsTotal: total, recordsFiltered: total })
    },
    getStatusesArray() {
      let statuses = []

      switch (this.selectedStatus) {
        case 1:
          statuses = this.conf.simulationStatusesProposal ? this.conf.simulationStatusesProposal.split('-') : []
          break
        case 2:
          statuses = this.conf.simulationStatusesStudy ? this.conf.simulationStatusesStudy.split('-') : []
          break
        case 3:
          statuses = this.conf.simulationStatusesDecision ? this.conf.simulationStatusesDecision.split('-') : []
          break
        case 4:
          statuses = this.conf.simulationStatusesContract ? this.conf.simulationStatusesContract.split('-') : []
          break
        case 5:
          statuses = this.conf.simulationStatusesRefusal ? this.conf.simulationStatusesRefusal.split('-') : []
          break
        case 6:
          statuses = this.conf.simulationStatusesError ? this.conf.simulationStatusesError.split('-') : []
          break
        default:
          statuses = this.conf.simulationStatusesDefault ? this.conf.simulationStatusesDefault.split('-') : []
      }

      return statuses
    },
    async download() {
      // Show a notification when the download starts
      this.toast(this.$root.$t('home.export.generating'))

      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hours = date.getHours()
      var minutes = date.getMinutes()
      var seconds = date.getSeconds()

      let formatDate = `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`

      // TODO: remove this when export will handle statuses array
      const searchParams = new URLSearchParams(this.searchParams.toString())

      if (searchParams.has('statuses[]')) {
        searchParams.delete('statuses[]')
        searchParams.set('status', this.getStatusesArray().join('-'))
      }

      await this.downloadFile(`quotations/export?${searchParams.toString()}`, `Simulation-${formatDate}.xlsx`)

      this.toast(this.$t('home.export.sucess'))
    },
    setUrl() {
      let url = ''
      switch (this.selectedStatus) {
        case 1:
          url += 'status=' + this.conf.simulationStatusesProposal
          break
        case 2:
          url += 'status=' + this.conf.simulationStatusesStudy
          break
        case 3:
          url += 'status=' + this.conf.simulationStatusesDecision
          break
        case 4:
          url += 'status=' + this.conf.simulationStatusesContract
          break
        case 5:
          url += 'status=' + this.conf.simulationStatusesRefusal
          break
        case 6:
          url += 'status=' + this.conf.simulationStatusesError
          break
        default:
          url += 'status=' + this.conf.simulationStatusesDefault
      }

      if (this.unit > 0) {
        url = url + '&unit=' + this.unit
      }
      if (this.platformSalesman > 0) {
        url = url + '&platformSalesman=' + this.platformSalesman
      }
      if (this.supplier > 0) {
        url = url + '&supplier=' + this.supplier
      }
      if (this.client > 0) {
        url = url + '&client=' + this.client
      }
      if (this.refinancer > 0) {
        url = url + '&refinancer=' + this.refinancer
      }
      if (this.createdAt) {
        url = url + '&createdAt=' + this.prepareDateForFilter(this.createdAt)
      }
      if (this.createdAtEnd) {
        url = url + '&createdAtEnd=' + this.prepareDateForFilter(this.createdAtEnd)
      }
      if (this.marketType > 0) {
        url += '&marketType=' + this.marketType
      }

      return url
    },
    prepareDateForFilter(dateString) {
      var dateParts = dateString.split('/')
      var date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      return date.toISOString()
    },
    renderId: function (data, type, row, meta) {
      return (
        "<a href='../devis/simulation.php?i=" + data + "&p=devis&index=simulation' target='_blank'>" + data + '</a>'
      )
    },
    renderTable() {
      this.cancelPendingRequest()
      this.$refs.liste.renderDataTable()
      this.loadFilterOptions()
    },
    async cancel() {
      if (!this.simulationToCancel) {
        return
      }

      await this.deleteJSON('quotations/' + this.simulationToCancel)
      this.hideSimulationCancelModal()
      this.renderTable()
    },
    showSimulationCancelModal(simulationId) {
      this.simulationToCancel = simulationId
    },
    hideSimulationCancelModal() {
      this.simulationToCancel = null
    },

    renderContractType(data) {
      if (!data) {
        return '-'
      }

      const translationKey = `contract.types.${data.toLowerCase()}`
      const translated = this.$t(translationKey)

      return translated !== translationKey ? translated : data
    },

    renderK2OrderNumber(data, type, row) {
      if (!conf.orderExternalUrlTemplate || !data) {
        return data ?? '-'
      }

      const url = String(conf.orderExternalUrlTemplate)
        .replace('{{ simulationId }}', row.id)
        .replace('{{ orderNumber }}', row.orderNumber)

      return `<a href="${url}" target="_blank">${data}</a>`
    },
  },

  watch: {
    selectedStatus(val) {
      if (val || val === 0) {
        this.renderTable()
      }
    },
  },
  mounted() {
    $(document).on('click', '#liste [data-action="delete"]', async (e) => {
      this.showSimulationCancelModal(e.target.id)
    })
  },
}
</script>
<template>
  <PageLayout menu="simulations-index">
    <MainContainer title-t="menu.mySimulations">
      <BlockContent>
        <TableMenu
          :status="Number(selectedStatus)"
          :filters="tableFilters"
          :submenu-labels="submenuLabels"
          endpoint="quotations"
          :filter-options="filters"
          @set-selected-status="setSelectedStatus"
          @download="download"
          @set-date="setDateTable"
          @update-filter-data="updateFilterData"
        >
        </TableMenu>
        <CardContent>
          <DataTable
            ref="liste"
            id="liste"
            :columns="columns"
            :fetch="getSimulations"
            :order="[{ dir: 'desc', name: 'createdAt' }]"
            :zero-records="$t('simulation.list.zeroRecords')"
            :first-load="false"
            pagination-mode="server"
          >
          </DataTable>
        </CardContent>
      </BlockContent>
    </MainContainer>
    <CancelSimulationConfirmationModal
      v-if="simulationToCancel"
      ref="confirmationCancel"
      @confirm="cancel"
      @cancel="hideSimulationCancelModal"
    />
  </PageLayout>
</template>
